import { useRealtimeStatus, type RealtimeStatus } from "@/contexts/RealtimeConnectionContext";

const STATUS_LABEL: Record<RealtimeStatus, string> = {
  live: "Live",
  connecting: "Connecting…",
  reconnecting: "Reconnecting…",
  offline: "Offline",
};

/**
 * Small pill in the app header showing the overall realtime connection state.
 */
export function RealtimeStatusBadge() {
  const status = useRealtimeStatus();
  const label = STATUS_LABEL[status];
  return (
    // Fixed-width slot reserves room for the widest state so the pill itself can
    // hug its own text (fit-content) without shifting the nav to its right when
    // the label changes.
    <span className="realtime-status-badge-slot">
      <span
        className={`realtime-status-badge realtime-status-badge--${status}`}
        title={status}
        role="status"
        aria-live="polite"
      >
        <span className="realtime-status-badge__dot" aria-hidden />
        <span className="realtime-status-badge__label">{label}</span>
      </span>
    </span>
  );
}
